
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class H5Mark extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean;
  @Prop({ type: Boolean, default: false }) isLoading!: boolean;
  @Prop({ type: String, default: "" }) text?: string;
  @Prop({ type: Number, default: 2000 }) time?: number;

  timer = 0;

  @Watch("visible", { immediate: true })
  handleVisibleChange() {
    if (this.visible) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$emit("update:visible", false);
      }, this.time);
    } else {
      clearTimeout(this.timer);
    }
  }

  @Watch("isLoading", { immediate: true })
  handleIsLoadingChange() {
    if (!this.isLoading) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$emit("update:visible", false);
      }, this.time);
    } else {
      clearTimeout(this.timer);
    }
  }

  beforeDestroy() {
    clearTimeout(this.timer);
  }
}
